package com.essntl.features.itinerary.ui.edit_itinerary.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.features.client.domain.model.ClientModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryState
import com.essntl.uikit.components.checkbox.EsCheckBoxColors
import com.essntl.uikit.components.checkbox.EsCheckBoxState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.EsRowDefaultItem
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ItineraryServicesSelected(
    state: EditItineraryState,
    onEvent: (EditItineraryEvent) -> Unit,
    onNavigation: (EditItineraryNavigation) -> Unit,
    selectedItineraryServiceList: List<ItineraryServiceModel>,
    itineraryServices: List<ItineraryServiceModel>,
    itinerary: ItineraryModel,
    clients: List<ClientModel>,
    isConcierge: Boolean,
) {
    val status = remember {
        mutableStateOf<ItineraryServiceModel.Status?>(null)
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.RoundedCornerSize))
            .background(MaterialTheme.esColorScheme.primary)
            .padding(
                vertical = EsConstants.ListRowVerticalPadding,
                horizontal = EsConstants.ListRowHorizontalPadding + EsConstants.SectionHorizontalPadding,
            )
            .height(40.dp),
    ) {
        EsRowDefaultItem(
            text = "",
            extraContent = {
                Text(
                    text = "${selectedItineraryServiceList.size} " +
                        if (selectedItineraryServiceList.size == 1) "service" else "services" +
                            " selected",
                    style = MaterialTheme.esTypography.p1Regular16.copy(color = Color.White),
                )
            },
            isFirst = true,
            showsCheckBox = true,
            checkBoxState = when {
                selectedItineraryServiceList.size == itineraryServices.size ->
                    EsCheckBoxState.Checked

                selectedItineraryServiceList.isNotEmpty() ->
                    EsCheckBoxState.Indeterminate

                else ->
                    EsCheckBoxState.Unchecked
            },
            checkBoxColors = EsCheckBoxColors(
                backgroundCheckedBoxColor = Color.White,
                backgroundUncheckedBoxColor = MaterialTheme.esColorScheme.secondaryHover,
                borderCheckedBoxColor = Color.Transparent,
                checkMarkColor = MaterialTheme.esColorScheme.primary,
                disabledCheckedBoxColor = MaterialTheme.esColorScheme.secondaryDisabled,
                disabledCheckMarkColor = MaterialTheme.esColorScheme.iconDisabled,
            ),
            onCheckboxClicked = {
                onEvent(EditItineraryEvent.SelectAllItineraryService)
            },
            weight = 2f,
        )

        EsRowDefaultItem(
            text = "",
            extraContent = {
                ItineraryServiceStatusDropDown(
                    status = status.value,
                    onStatusSelected = { newStatus ->
                        status.value = newStatus
                        onEvent(EditItineraryEvent.UpdateSelectedItineraryServiceStatus(status = newStatus))
                    },
                )
            },
            isFirst = true,
        )

        EsRowDefaultItem(
            text = "",
            extraContent = {
                ItineraryServiceActions(
                    state = state,
                    onNavigation = onNavigation,
                    selectedItineraryServiceList = selectedItineraryServiceList,
                    itinerary = itinerary,
                    clients = clients,
                    isConcierge = isConcierge,
                )
            },
            isFirst = true,
        )

        Spacer(modifier = Modifier.weight(1f))
    }
}